import React from 'react';

interface YearDropdownProps {
  onChange: (year: number) => void;
}

const YearDropdown: React.FC<YearDropdownProps> = ({ onChange }) => {
  const currentYear = new Date().getFullYear();
  const startYear = 2020;

  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => currentYear - i,
  );

  return (
    <select onChange={e => onChange(Number(e.target.value))}>
      {years.map((year, index) => (
        <option key={index} value={year}>
          {year}
        </option>
      ))}
    </select>
  );
};

export default YearDropdown;
